import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 16 100",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 100\" id=\"icon-collapse\"><defs><style>#icon-collapse .a{fill:#d4d7de;}#icon-collapse .b{fill:#828ead;}</style></defs><g transform=\"translate(-877 -544)\"><rect class=\"a\" width=\"16\" height=\"100\" rx=\"8\" transform=\"translate(877 544)\" /><path class=\"b\" d=\"M337.4,277.6l-5.243,4.938a1.181,1.181,0,0,1-1.224.232,1.064,1.064,0,0,1-.7-.981v-9.875a1.064,1.064,0,0,1,.7-.981,1.213,1.213,0,0,1,.433-.084,1.108,1.108,0,0,1,.791.316L337.4,276.1a1.04,1.04,0,0,1,.327.749A.985.985,0,0,1,337.4,277.6Z\" transform=\"translate(1218.986 870.85) rotate(180)\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/collapse.svg
// module id = Sv15
// module chunks = 10